<template>
  <div>
    <ul class="flex border-b-2 select-none bg-white">
      <li
        class="flex-1 text-center -mb-2px py-3 border-b-2 text-base font-medium"
        :class="[
          isSectionFocused('general') ? 'border-blue-600' : '',
          isSectionFocused('general') ? 'text-gray-900' : 'text-gray-600',
        ]"
        @click="setFocusedSection('general')"
      >
        General
      </li>
      <li
        class="flex-1 text-center -mb-2px py-3 border-b-2 text-base font-medium"
        :class="[
          isSectionFocused('issuer') ? 'border-blue-600' : '',
          isSectionFocused('issuer') ? 'text-gray-900' : 'text-gray-600',
        ]"
        @click="setFocusedSection('issuer')"
      >
        Issuer
      </li>
      <li
        class="flex-1 text-center -mb-2px py-3 border-b-2 text-base font-medium"
        :class="[
          isSectionFocused('recipient') ? 'border-blue-600' : '',
          isSectionFocused('recipient') ? 'text-gray-900' : 'text-gray-600',
        ]"
        @click="setFocusedSection('recipient')"
      >
        Recipient
      </li>
      <li
        class="flex-1 text-center -mb-2px py-3 border-b-2 text-base font-medium"
        :class="[
          isSectionFocused('details') ? 'border-blue-600' : '',
          isSectionFocused('details') ? 'text-gray-900' : 'text-gray-600',
        ]"
        @click="setFocusedSection('details')"
      >
        Details
      </li>
      <li
        class="flex-1 text-center -mb-2px py-3 border-b-2 text-base font-medium"
        :class="[
          isSectionFocused('preview') ? 'border-blue-600' : '',
          isSectionFocused('preview') ? 'text-gray-900' : 'text-gray-600',
        ]"
        @click="setFocusedSection('preview')"
      >
        Preview
      </li>
    </ul>
    <div class="p-4 sm:p-6 space-y-6">
      <slot v-if="isSectionFocused('general')" name="general" />
      <slot v-if="isSectionFocused('issuer')" name="issuer" />
      <slot v-if="isSectionFocused('recipient')" name="recipient" />
      <slot v-if="isSectionFocused('details')" name="details" />
      <slot v-if="isSectionFocused('preview')" name="preview" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      focusedSection: 'general',
    };
  },
  methods: {
    setFocusedSection(section) {
      this.focusedSection = section;
    },
    isSectionFocused(section) {
      return this.focusedSection === section;
    },
  },
};
</script>
